import * as Util from "../common/util";
import * as Data from "../interfaces/data";

// These values are defined in the API and determine
// what kinf of verification is performed.
export const WEST_VIRGINIA_CRITERIA_IN_WORK_FORCE = "WORKFORCE";
export const WEST_VIRGINIA_CRITERIA_IN_OASIS = "OASIS";
export const WEST_VIRGINIA_CRITERIA_NONE = "NONE";

export interface IRegistrationCodeRequest {
    RegistrationCode: string;
    RegistrationCriteria: string;
}

export interface ICreateUserRequest {
    RegistrationCode: string;
    RegistrationCriteria: string;
    UserName: string;
    Password: string;
    ConfirmPassword: string;
    Email: string;
    FirstName: string;
    LastName: string;
    TimeZoneID: number;
}

export interface IUserSelfRegistrationValidateResponse {
    /// Returns true if the code is valid
    IsValid: boolean;

    /// If code is invalid, reasons a reason why
    ValidationMessage: string;
}

export function ValidateRegistrationCode(request: IRegistrationCodeRequest): JQueryDeferred<Data.IResponse<IUserSelfRegistrationValidateResponse>> {
    return Util.callWebService(
        "/api/UserRegistration/ValidateRegistrationCode", "POST", request);
}

export function CreateUser(request: ICreateUserRequest): JQueryDeferred<Data.IResponse<boolean>> {
    return Util.callWebService(
        "/api/UserRegistration/CreateUserSelfRegistration", "POST", request);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/selfRegistrationData.ts